import ApiService from '../../services/api.service';
import DivisionModel from '../division/division-model';
import MedialibraryModel from '../medialibrary/medialibrary-model';
import OwnerModel from '../owner/owner-model';
import PersonalinfotypeModel from '../personalinfotype/personalinfotype-model';
import RegionModel from '../region/region-model';
import ScheduleModel from '../schedule/schedule-model';
import UserModel from '../user/user-model';

export default class PersonalinfoModel {
    id: number;
    name: string;
    description: string;
    status: string;
    owner: any;
    ownerCaption: string;
    personalinfotype: any;
    personalinfotypeLength: number;
    personalinfotypeCaption: string;
    personalinfotypeType: any;
    phone: string;
    email: any;
    birthplace: any;
    birthplaceCaption: string;
    birthdate: any;
    gender: string;
    division: any;
    divisionCaption: string;
    schedule: any;
    scheduleCaption: string;
    user: any;
    userCaption: string;
    userEmail: string;
    image: any;
    imageId: number;
    imageUrl: string;
    
    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        let owner = datarow.owner?.data? new OwnerModel(datarow.owner?.data) : datarow.owner;
        this.owner = owner?.id;
        this.ownerCaption = owner?.name;
        this.personalinfotype = datarow.personalinfotype?.data?.map((d: any) => new PersonalinfotypeModel(d));
        this.personalinfotypeLength = this.personalinfotype?.length || 0;
        this.personalinfotypeCaption = this.personalinfotype?.[0]?.name;
        this.personalinfotypeType = this.personalinfotype?.[0]?.type;
        this.phone = datarow.phone;
        this.email = datarow.email;
        let birthplace = datarow.birthplace?.data? new RegionModel(datarow.birthplace?.data) : datarow.birthplace;
        this.birthplace = birthplace?.id;
        this.birthplaceCaption = birthplace?.name;
        this.birthdate = datarow.birthdate;
        this.gender = datarow.gender;
        let division = datarow.division?.data? new DivisionModel(datarow.division?.data) : datarow.division;
        this.division = division?.id;
        this.divisionCaption = division?.name;
        let schedule = datarow.schedule?.data? new ScheduleModel(datarow.schedule?.data) : datarow.schedule;
        this.schedule = schedule?.id;
        this.scheduleCaption = schedule?.name;
        let user = datarow.user?.data? new UserModel(datarow.user?.data) : datarow.user;
        this.user = user?.id;
        this.userCaption = user?.name;
        this.userEmail = user?.useremail;
        this.image = datarow.image?.data?.map((d: any) => new MedialibraryModel(d))?.[0];
        this.imageId = this.image?.id;
        this.imageUrl = this.image? ((this.image.url?.startsWith('http')? '' : ApiService.svrUrl) + this.image.url) : '';
        
    } 

    public static endPoint: string = 'personal-infos';
    public static endPointMedia: string = 'api::personal-info.personal-info';
    public static endPointFilter2 = (personalinfotypeType?: string, userId?: number) => {
        return ('?populate[owner][sort]=id' +
            '&populate[personalinfotype]' + (personalinfotypeType? '[filters][type][$eq]=' + personalinfotypeType : '[sort]=id') +
            '&populate[image][sort]=id' +
            '&populate[user][sort]=id' +
            '&populate[schedule][sort]=id' +
            '&populate[division][sort]=id' +
            (userId? '&filters[user][id]=' : '&filters[id]=')
    );
    }
    public static endPointFilterList = (personalinfotypeType?: string, scheduleId?: number) => {
        const owner = OwnerModel.getOwner();
        return ( '?populate=*&sort=name&filters[owner]=' + owner + 
            (personalinfotypeType? '&filters[personalinfotype][type]=' + personalinfotypeType : '') + 
            (scheduleId? '&filters[schedule]=' + scheduleId : '')
        )
    } 
    public static url: string = '/personalinfo';
    public static caption: string = 'Personal Info';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        owner: +OwnerModel.getOwner(),
        ownerCaption: OwnerModel.getOwnerCaption(),   
        personalinfotype: [],   
        personalinfotypeLength: 0,   
        personalinfotypeCaption: '',   
        personalinfotypeType: null,   
        phone: '',
        email: null,
        birthplace: null,
        birthplaceCaption: '',   
        birthdate: null,
        gender: 'male',
        division: null,
        divisionCaption: '',
        schedule: [],
        scheduleCaption: '',
        user: null,
        userCaption: '',
        userEmail: '',
        image: null,
        imageId: 0,
        imageUrl: '',
        
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
        { name: 'personalinfotype', required: true },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
    public static optionGender = [
        { name: 'male', caption: 'Male' },
        { name: 'female', caption: 'Female' },
    ]
}